<template>
  <ul>
    <li><a href="https://www.partsdata.de/search?sSearch=CU-CHAIN-120">
      <img src="https://www.partsdata.de/themes/Frontend/Ostrich/frontend/_public/img/flag_de.png">
    </a></li>
    <li><a href="https://www.partsdata.eu/search?sSearch=CU-CHAIN-120" rel="nofollow">
      <img src="https://www.partsdata.de/themes/Frontend/Ostrich/frontend/_public/img/flag_en.png">
    </a></li>
    <li><a href="https://www.partsdata.fr/search?sSearch=CU-CHAIN-120" rel="nofollow">
      <img src="https://www.partsdata.de/themes/Frontend/Ostrich/frontend/_public/img/flag_fr.png">
    </a></li>
  </ul>
</template>

<script>
export default {
  name: 'LanguagePicker'
}
</script>

<style scoped lang="sass">
  ul
    background-color: lighten($dark-blue, 10)
    border: 1px solid $blue
    border-top: none
    position: relative
    margin: 0px
    padding: 0px
    float: right
    border-radius: 0 0 $border-radius $border-radius
    display: flex
    flex-direction: row-reverse
    &:hover
      li
        display: flex
    li
      list-style: none
      display: none
      &:first-child
        border-top: none
        display: block
      a
        font-size: 0.9em
        color: #fff
        display: inline-block
        padding: .6em .6em .3em .6em
        border-radius: 0 0 $border-radius $border-radius
        img
          width: 17px
        //margin-left: .3em
        &:hover
          background-color: $blue
</style>
